import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null; // { launch_mode, unlocked } — one fetch per page load

/** Coming-soon switch (admin-controlled). Returns null while loading, else
 *  true only when the splash should be shown to this visitor. */
export function useLaunchMode() {
  const [state, setState] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api
      .get("/launch/status")
      .then(({ data }) => { cached = data; setState(data); })
      .catch(() => { cached = { launch_mode: false, unlocked: false }; setState(cached); });
  }, []);
  if (state === null) return null;
  return state.launch_mode && !state.unlocked;
}

export function resetLaunchMode() {
  cached = null;
}
